import { Icon } from '@/components/Icon';
import colors from '@/config/colors';
import { ReactNode } from 'react';
import { ControllerFieldState } from 'react-hook-form';
import { Platform, TextInput, TextInputProps, View } from 'react-native';
import { Text } from '@/components/Text';

interface Props extends TextInputProps {
  field: any;
  fieldState: ControllerFieldState;
}

export const EmailInput = ({ fieldState, field }: Props): ReactNode => {
  const { value, onChange, onBlur } = field;
  const { error } = fieldState;

  const borderColor = error ? 'border-red-600' : 'border-green-neolexon';
  const textColor = error ? 'text-red-700' : 'text-green-neolexon';

  return (
    <View className="flex-col gap-1">
      <View
        className={`border ${borderColor}  rounded-3xl flex-row items-center px-3 overflow-hidden`}
      >
        <Icon name="user" className={`${textColor} text-[28px]`} />
        <TextInput
          id="email-input"
          className="flex-1 p-3 text-lg font-medium"
          placeholder="E-Mail"
          autoComplete="off"
          placeholderTextColor={colors.twGrey}
          autoCapitalize="none"
          onBlur={onBlur}
          onChangeText={onChange}
          value={value}
          style={{
            ...(Platform.OS === 'ios'
              ? { lineHeight: 0, color: colors.newUI.therapist.textBlue100 }
              : { color: colors.newUI.therapist.textBlue100 }),
          }}
        />
      </View>
      <Text className="text-red-700 text-base pl-1">{error?.message}</Text>
    </View>
  );
};
